import { Item } from '../../common/snippets'
import { AcountingHeading } from './common/AcountingHeading'
import { Box, Button } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { useState } from 'react'
import moment from 'moment'
import { floatFilter, focusElemnt } from '../../common/helper'
import useToken from '../../helpers/useTokens'
import { TableComponent } from '../../common/TableComponent'
import { BranchPayableHeaders, criteriaHeaders, dateHeaders } from './contants'
import LineinputV2 from '../../common/lineinputV2'
import { accumulateTotals } from '../Reports/NonMovementTable/utilFucntions'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import { AddEditHeaderModal } from './addEditHeaderModal'
import { GetRequest, PostRequest } from '../../common/api'
import { urls } from '../../common/constants'
const reportName = 'Branch Payable Report'
export const BranchPayable = () => {
  const { loginData } = useToken()
  const setLoader = useSetAtom(globalLoaderAtom)

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [tableData, setTableData] = useState([])
  const setAlert = useSetAtom(alertAtom)
  const [modal, setModal] = useAtom(modalAtom)

  const headers = BranchPayableHeaders.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
  }))

  const handleChange = (e, id, key, list) => {
    const newList = list.map((col, i) => (i === id ? { ...col, [key]: e || 0 } : col))
    setTableData(handleInputs(newList))
  }
  const fetchTableData = () => {
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
    }
    GetRequest(urls.getBranchExpenseDetails, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const fomattedData = formatTableData(res.Data.Table)
        setTableData(fomattedData)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const handleEdit = (e, index, disabled, list) => {
    e.preventDefault()
    e.stopPropagation()
    const newList = list.map((col, i) => (i === index ? { ...col, disabled: disabled } : col))
    if (disabled) {
      const item = newList[index]
      const data = {
        CompanyID: loginData.intCompanyID,
        TransactionID: item.TransactionID,
        PaymentAmt: +item.PaymentAmt || 0,
        UserID: loginData.intUserID,
        Remarks: item.Remarks || '',
        ExpenseAmt: +item.ExpenseAmt || 0,
      }
      setLoader(true)
      PostRequest(urls.branchExpensePaymentUpdate, data)
        .then((res) => {
          if (res.status !== 'Success') {
            throw new Error(res?.ErrMessage || 'Request Failed')
          }
          fetchTableData()
        })
        .catch((err) => {
          setAlert({ show: true, msg: err.message, nextId: '' })
        })
        .finally(() => setLoader(false))
    } else {
      setTableData(handleInputs(newList))
    }
  }

  const formatTableData = (list) => {
    list = list.map((col) => ({
      ...col,
      dataType: 'entry',
      disabled: true,
      TransDate: moment(col.TransDate).format('DD-MM-YYYY'),
    }))
    const grouped = list.reduce((map, curr) => {
      const key = curr.TransDate

      if (!map.has(key)) {
        map.set(key, [])
      }

      map.get(key).push(curr)

      return map
    }, new Map())
    const numericKeys = BranchPayableHeaders.reduce((acc, curr) => {
      if (curr.xlCol.dataType === 'quantity') {
        acc.push(curr.field?.replace(/_view$/, ''))
      }
      return acc
    }, [])
    let sn = 1
    const formatted = Array.from(grouped.entries())
      .sort(([a], [b]) => moment(b, 'DD-MM-YYYY').valueOf() - moment(a, 'DD-MM-YYYY').valueOf())
      .flatMap(([transDate, items]) => {
        items.forEach((row) => {
          row.SN = sn++
        })
        const groupTotal = accumulateTotals(items, numericKeys)
        const groupTotal_vew = Object.fromEntries(Object.entries(groupTotal).map(([key, value]) => [`${key}_view`, value]))
        return [
          ...items,
          {
            dataType: 'total',
            [BranchPayableHeaders[0].field]: `TOTAL: ${transDate}`,
            align: { [BranchPayableHeaders[0].field]: 'right' },
            colSpan: { [BranchPayableHeaders[0].field]: 5 },
            ...groupTotal,
            ...groupTotal_vew,
          },
        ]
      })
    const data = handleInputs(formatted)
    return data
  }
  const handleInputs = (list) => {
    return list.map((col, index) =>
      col.dataType === 'entry'
        ? {
            ...col,
            PaymentAmt_view: (
              <LineinputV2
                key={index}
                filter={floatFilter}
                onBlur={(e) => handleChange(e.target.value, index, 'PaymentAmt', list)}
                name="PaymentAmt"
                id={`PaymentAmt${index}`}
                value={col.PaymentAmt}
                disabled={col.disabled}
              />
            ),
            ExpenseAmt_view: (
              <LineinputV2
                key={index}
                filter={floatFilter}
                onBlur={(e) => handleChange(e.target.value, index, 'ExpenseAmt', list)}
                name="ExpenseAmt"
                id={`ExpenseAmt${index}`}
                value={col.ExpenseAmt}
                disabled={col.disabled || col.IsFixed === 1}
              />
            ),
            Remarks_view: (
              <LineinputV2
                key={index}
                onBlur={(e) => handleChange(e.target.value, index, 'Remarks', list)}
                name="Remarks"
                id={`Remarks${index}`}
                value={col.Remarks}
                disabled={col.disabled}
              />
            ),
            edit_view: (
              <Button
                id={`editButton${index}`}
                onClick={(e) => handleEdit(e, index, !col.disabled, list)}
                variant={col.disabled ? 'outlined' : 'contained'}
                color="secondary"
                disabled={col.IsEditable !== 1}
                style={{ height: '30px', ...sx.novp }}
              >
                {col.disabled ? 'Edit' : 'Save'}
              </Button>
            ),
          }
        : col
    )
  }
  const handleAddEdit = () => {
    setModal('branchPayableAddEdit')
  }
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY'),
    toDate: toDate.format('DD-MM-YYYY'),
    dataType: 'entry',
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <AcountingHeading reportName={reportName.slice(0, -7)} />
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompany}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            minWidth="250px"
          />
        </Item>

        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            name={'from_date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            name={'to_date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt('buttonGo')
            }}
            width="210px"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonLoad"
            onClick={fetchTableData}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            Load
          </Button>
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonLoad"
            onClick={handleAddEdit}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            Add / Edit Expense Header
          </Button>
        </Item>
      </Box>
      {tableData.length ? (
        <TableComponent
          reportName={reportName}
          criteriaHeaders={dateHeaders}
          criteriaData={[criteriaData]}
          tableData={tableData}
          mainHeader={headers}
        />
      ) : (
        <></>
      )}
      {modal === 'branchPayableAddEdit' && <AddEditHeaderModal />}
    </Item>
  )
}
